import {useState} from "react";
import {Send} from "lucide-react";
import {FormModal} from "@/components/UI";
import {apiPost} from "@/lib/api";

export default function SuggestBrandModal({close, notify}) {
  const [f, setF] = useState({name: "", category: "", location: "", reason: "", link: ""});
  const ch = e => setF({...f, [e.target.name]: e.target.value});
  const submit = async (e) => {
    e.preventDefault();
    try {
      await apiPost("/brand-suggestions", f);
      notify("Thanks — we'll review your suggestion");
      close();
    } catch { notify("Please try again"); }
  };
  return (
    <FormModal title="Know a brand we should list?" eyebrow="SUGGEST A BRAND" close={close} testId="suggest-brand">
      <p className="modal-sub">Share any business, maker or service you&rsquo;d like to see here. Our team reviews every suggestion.</p>
      <form onSubmit={submit}>
        <label>Brand or business name
          <input data-testid="suggest-name" required name="name" value={f.name} onChange={ch} placeholder="e.g. Nalanda Crafts"/>
        </label>
        <label>Category
          <input data-testid="suggest-category" name="category" value={f.category} onChange={ch} placeholder="e.g. Home decor, Food, Travel"/>
        </label>
        <label>Location
          <input data-testid="suggest-location" name="location" value={f.location} onChange={ch} placeholder="City, country"/>
        </label>
        <label>Why should we list them?
          <textarea data-testid="suggest-reason" name="reason" value={f.reason} onChange={ch} placeholder="A short note about what makes them special"/>
        </label>
        <label>Website or Instagram (optional)
          <input data-testid="suggest-link" name="link" value={f.link} onChange={ch} placeholder="https://..."/>
        </label>
        <button data-testid="suggest-submit" className="coral-button full" type="submit">Send suggestion <Send size={14}/></button>
      </form>
    </FormModal>
  );
}
